export default {
  siteName: 'Agentur-Cockpit',
  siteIcon: 'ion-flash',
  footerText: `Agentur-Cockpit @ ${new Date().getFullYear()}`,
  enableAnimatedRoute: false,
  apiUrl: 'http://yoursite.com/api/',
  google: {
    analyticsKey: 'UA-xxxxxxxxx-1',
  },
  dashboard: '/dashboard',
};
